import React from 'react';
import './index.scss';

const LOCAL_JQUERY_SRC = `${process.env.PUBLIC_URL}/static/js/jquery-3.5.1.min.js`;
const LOCAL_JQUERY_SCRIPT_ID = 'izuche-local-jquery';

const MANAGE_PAGE_CONFIG = {
    bg: 'https://web-front.imrcar.com/static/share/images/h5jumpApp_izu_bg.png',
    btnbg: 'https://web-front.imrcar.com/static/share/images/h5jumpApp_izu_btnbg.png',
    icon: 'https://web-front.imrcar.com/static/share/images/h5jumpApp_point.png',
    arrow: 'https://web-front.imrcar.com/static/share/images/h5jumpApp_arrow.svg',
    logo: 'https://web-front.izuche.com/static/logo/izu%20logo256.png',
    h1: '首汽租车 APP下载',
    h5: '不同在于用心',
    btnName: '下载首汽租车App',
    iosDownloadUrl: 'https://apps.apple.com/cn/app/id995243029',
    androidDownloadUrl:
        'https://sqzl-android.oss-cn-beijing.aliyuncs.com/android/online/custom/10301/izuche-customer-6.1.1_241_release_202409211626_jiagu_sec_signed_official.apk'
};

const loadScript = ({id, src, shouldSkip}) =>
    new Promise((resolve, reject) => {
        if (shouldSkip && shouldSkip()) {
            resolve();
            return;
        }

        const current = document.getElementById(id);
        if (current) {
            if (current.dataset.loaded === 'true') {
                resolve();
                return;
            }
            current.addEventListener('load', resolve, {once: true});
            current.addEventListener(
                'error',
                () => reject(new Error(`脚本加载失败: ${src}`)),
                {once: true}
            );
            return;
        }

        const script = document.createElement('script');
        script.id = id;
        script.src = src;
        script.async = false;
        script.onload = () => {
            script.dataset.loaded = 'true';
            resolve();
        };
        script.onerror = () => reject(new Error(`脚本加载失败: ${src}`));
        document.body.appendChild(script);
    });

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.isWeChat = /MicroMessenger/i.test(window.navigator.userAgent);
        this.previousTitle = document.title;
        this.remTimer = null;
        this.pageFrameSnapshot = null;
    }

    componentDidMount() {
        document.title = '首汽租车APP下载';
        this.applyPageFrameStyles();
        this.refreshRem();
        window.addEventListener('resize', this.handleResize, false);
        window.addEventListener('pageshow', this.handlePageShow, false);
        this.bootstrapLocalScript();
    }

    componentWillUnmount() {
        clearTimeout(this.remTimer);
        window.removeEventListener('resize', this.handleResize, false);
        window.removeEventListener('pageshow', this.handlePageShow, false);
        this.restorePageFrameStyles();

        document.title = this.previousTitle;
    }

    applyPageFrameStyles = () => {
        const docEl = document.documentElement;
        const body = document.body;
        const root = document.getElementById('root');

        this.pageFrameSnapshot = {
            docWidth: docEl.style.width,
            docHeight: docEl.style.height,
            docOverflow: docEl.style.overflow,
            bodyWidth: body.style.width,
            bodyHeight: body.style.height,
            bodyOverflow: body.style.overflow,
            bodyMargin: body.style.margin,
            rootWidth: root ? root.style.width : '',
            rootHeight: root ? root.style.height : '',
            rootOverflow: root ? root.style.overflow : ''
        };

        docEl.style.width = '100%';
        docEl.style.height = '100%';
        docEl.style.overflow = 'hidden';
        body.style.width = '100%';
        body.style.height = '100%';
        body.style.overflow = 'hidden';
        body.style.margin = '0';

        if (root) {
            root.style.width = '100%';
            root.style.height = '100%';
            root.style.overflow = 'hidden';
        }
    };

    restorePageFrameStyles = () => {
        if (!this.pageFrameSnapshot) {
            return;
        }

        const docEl = document.documentElement;
        const body = document.body;
        const root = document.getElementById('root');

        docEl.style.width = this.pageFrameSnapshot.docWidth;
        docEl.style.height = this.pageFrameSnapshot.docHeight;
        docEl.style.overflow = this.pageFrameSnapshot.docOverflow;
        body.style.width = this.pageFrameSnapshot.bodyWidth;
        body.style.height = this.pageFrameSnapshot.bodyHeight;
        body.style.overflow = this.pageFrameSnapshot.bodyOverflow;
        body.style.margin = this.pageFrameSnapshot.bodyMargin;

        if (root) {
            root.style.width = this.pageFrameSnapshot.rootWidth;
            root.style.height = this.pageFrameSnapshot.rootHeight;
            root.style.overflow = this.pageFrameSnapshot.rootOverflow;
        }
    };

    handleResize = () => {
        clearTimeout(this.remTimer);
        this.remTimer = window.setTimeout(this.refreshRem, 300);
    };

    handlePageShow = event => {
        if (event.persisted) {
            this.handleResize();
        }
    };

    handleFallbackDownload = () => {
        if (typeof window.downloadFn === 'function') {
            return;
        }

        if (this.isWeChat) {
            this.showToast('请点击右上角在浏览器中打开');
            return;
        }

        const ua = window.navigator.userAgent || '';
        const isAndroid = /Android/i.test(ua);
        window.location.href = isAndroid
            ? MANAGE_PAGE_CONFIG.androidDownloadUrl
            : MANAGE_PAGE_CONFIG.iosDownloadUrl;
    };

    handleButtonKeyDown = event => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.handleFallbackDownload();
        }
    };

    refreshRem = () => {
        const docEl = document.documentElement;
        const width = docEl.getBoundingClientRect().width || window.innerWidth;
        const rem = Math.min(width, 540) / 10;

        docEl.style.fontSize = `${rem}px`;
        docEl.setAttribute('data-dpr', '1');

        if (document.body) {
            document.body.style.fontSize = '12px';
        }
    };

    bootstrapLocalScript = async () => {
        try {
            await loadScript({
                id: LOCAL_JQUERY_SCRIPT_ID,
                src: LOCAL_JQUERY_SRC,
                shouldSkip: () => Boolean(window.jQuery)
            });

            if (window.jQuery) {
                window.$ = window.jQuery;
            }
        } catch (error) {
            // jquery 只用于保持和原始页面依赖一致，加载失败不影响页面展示。
            // eslint-disable-next-line no-console
            console.error(error);
        }
    };

    showToast = (message, duration = 3000) => {
        const toast = document.createElement('div');
        toast.innerHTML = message;
        toast.style.cssText = [
            'font-size:.32rem',
            'color:#fff',
            'background-color:rgba(0,0,0,0.6)',
            'padding:10px 15px',
            'border-radius:4px',
            'position:fixed',
            'top:50%',
            'left:50%',
            'transform:translate(-50%, -50%)',
            'width:130px',
            'text-align:center',
            'z-index:9999'
        ].join(';');

        document.body.appendChild(toast);
        window.setTimeout(() => {
            toast.style.opacity = '0';
            window.setTimeout(() => {
                toast.remove();
            }, 500);
        }, duration);
    };

    render() {
        return (
            <div className="download-page-shell">
                <div
                    id="container"
                    className={`container${this.isWeChat ? ' is-wechat' : ''}`}
                    style={{backgroundImage: `url(${MANAGE_PAGE_CONFIG.bg})`}}
                >
                    <div className="top-box">
                        <div className="text-box">
                            <div className="text">
                                <span>点击右上角</span>
                                <img
                                    className="icon_src"
                                    src={MANAGE_PAGE_CONFIG.icon}
                                    alt="右上角图标"
                                />
                            </div>
                            <div className="text">选择在浏览器中打开</div>
                        </div>
                        <div className="arrow-box">
                            <img
                                className="arrow_src"
                                src={MANAGE_PAGE_CONFIG.arrow}
                                alt="提示箭头"
                            />
                        </div>
                    </div>
                    <div className="logo-box">
                        <img
                            className="logo_src"
                            src={MANAGE_PAGE_CONFIG.logo}
                            alt="首汽租车"
                        />
                    </div>
                    <h1 className="h1_text">{MANAGE_PAGE_CONFIG.h1}</h1>
                    <h5 className="h5_text">{MANAGE_PAGE_CONFIG.h5}</h5>
                    <div className="btn_box">
                        <div
                            id="btn"
                            onClick={this.handleFallbackDownload}
                            onKeyDown={this.handleButtonKeyDown}
                            role="button"
                            tabIndex={0}
                            style={{backgroundImage: `url(${MANAGE_PAGE_CONFIG.btnbg})`}}
                        >
                            {MANAGE_PAGE_CONFIG.btnName}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Index;
